<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="FAQs" pageTitle="FAQs" />
            <FaqContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import FaqContent from '../Faq/FaqContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'FaqPage',
    components: { MainHeader, PageTitle, FaqContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
